import React from 'react';
import ReactDOM from 'react-dom';
import { Mask } from '@unifocus/react-components';

let referenceCount = 0;

export const showMask = (skipRefCheck?: boolean) => {
   if (skipRefCheck || referenceCount === 0) {
      saveFocus();
      clearFocus();
      renderMaskComponentAfterOneSecondInterval();
   }

   referenceCount++;
};

export const hideMask = (skipRefCheck?: boolean) => {
   referenceCount--;

   if (skipRefCheck || referenceCount === 0) {
      stopRenderOfDelayedMaskComponent();
      renderMaskComponentBasedOnDeviceBrowser(false);
      restoreFocus();
   }
};

let focusedElement: HTMLElement;
let displayMaskTimeout: any;

const saveFocus = () => {
   focusedElement = document.activeElement as HTMLElement;
};

const clearFocus = () => {
   document.addEventListener('keydown', discardEventHandler);
   document.addEventListener('click', discardEventHandler);
   document.addEventListener('dblclick', discardEventHandler);

   if (focusedElement) {
      focusedElement.blur();
   }
};

const restoreFocus = () => {
   document.removeEventListener('keydown', discardEventHandler);
   document.removeEventListener('click', discardEventHandler);
   document.removeEventListener('dblclick', discardEventHandler);

   if (focusedElement && isHtmlElementVisuallyOnScreen(focusedElement)) {
      focusedElement.focus();
   }
};

const discardEventHandler = (event: Event) => {
   event.preventDefault();
   event.stopImmediatePropagation();
   event.stopPropagation();
};

const renderMaskComponentAfterOneSecondInterval = (): void => {
   showInitialMask(true);

   clearTimeout(displayMaskTimeout);
   displayMaskTimeout = setTimeout(() => {
      renderMaskComponentBasedOnDeviceBrowser(true);
   }, 1000);
};

const showInitialMask = (show: boolean) => {
   const unifocusMaskContainer: HTMLElement = getMaskContainer();

   if (show) {
      unifocusMaskContainer.classList.add('initial-mask');
   }
   else {
      unifocusMaskContainer.classList.remove('initial-mask');
   }
};

const stopRenderOfDelayedMaskComponent = (): void => {
   clearTimeout(displayMaskTimeout);
   showInitialMask(false);
};

const renderMaskComponentBasedOnDeviceBrowser = (show: boolean): void => {
   const maskContainer = getMaskContainer();

   ReactDOM.render(<Mask show={show}/>, maskContainer);
};

const getMaskContainer = () => {
   let unifocusMaskContainer: HTMLElement | null = document.getElementById('unifocus-mask-container');

   if (!unifocusMaskContainer) {
      unifocusMaskContainer = document.createElement('div');
      unifocusMaskContainer.id = 'unifocus-mask-container';
      unifocusMaskContainer.style.zIndex = '10000';

      document.body.appendChild(unifocusMaskContainer);
   }

   return unifocusMaskContainer;
};

const isHtmlElementVisuallyOnScreen = (el: Element) => {
   const bounding: ClientRect = el.getBoundingClientRect();

   return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
   );
};
